/**
 * import element ui lib
 */

import Vue from 'vue';
import Element from 'element-ui';
import VueClipboard from 'vue-clipboard2';
import '../assets/style/element-variables.scss';

Vue.use(Element);

Vue.use(VueClipboard);
